import './DeliveryItemText.css';

type DeliveryItemTextProps = {
  /** Предмет доставки (GDD «Предмет»), после вскрытия посылки. */
  text: string;
  className?: string;
};

export function DeliveryItemText({ text, className }: DeliveryItemTextProps) {
  return (
    <p
      className={['new-delivery-delivery-item-text', className]
        .filter(Boolean)
        .join(' ')}
    >
      {text}
    </p>
  );
}
